var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"none","d":"M20.626 12.632c.51-.322.903-.833 1.086-1.441a4.792 4.792 0 01-1.57.632A2.406 2.406 0 0018.34 11c-1.364 0-2.47 1.167-2.47 2.606 0 .204.02.404.063.594-2.053-.11-3.874-1.146-5.093-2.724a2.71 2.71 0 00-.335 1.311c0 .904.436 1.702 1.1 2.17a2.383 2.383 0 01-1.12-.326v.033c0 1.263.85 2.316 1.983 2.555a2.324 2.324 0 01-1.116.045c.313 1.035 1.226 1.79 2.308 1.81A4.798 4.798 0 0110 20.154a6.738 6.738 0 003.788 1.17c4.546 0 7.03-3.97 7.03-7.415 0-.113 0-.226-.006-.337a5.166 5.166 0 001.233-1.35c-.443.207-.92.348-1.419.41z","key":0}),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},React.createElement("circle",{"cx":"16","cy":"16","r":"15.5"}))]);
}

TwitterInline.defaultProps = {"width":"32","height":"32","fill":"#97979D","stroke":"#97979D"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
